/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react'
import HeadingButton from '../../components/Atoms/KycComponent/HeadingButton'
import SearchBar from '../../components/Atoms/SearchBar/SearchBar'
import BankStatement from './components/BankDataCard'
import { alertActions, coinManagementActions, kycVerificationListActions, userManagementActions } from '../../_actions'
import { useDispatch, useSelector } from 'react-redux'
import Pagination from '../../components/Pagination/Pagination'
// import NoData from '../../components/Atoms/NoData'
import ActionPopup from '../../components/Atoms/ActionPopup/ActionPopup'
import moment from 'moment'
import ViewHistoryModal from '../../components/Atoms/popup/ViewHistoryModal'
import { useLocation, useNavigate } from 'react-router'
import Loader from '../../components/Atoms/Loader'
import Nodata from '../../components/Atoms/NoData/NoData'
import useDebounce from '../../Custom Hooks/Debounce'
const size = 5
const BankRequestIndividual = () => {
  const dispatch = useDispatch()
  const selector = useSelector(state => state)
  const [bankList, setBankList] = useState([])
  const navigate = useNavigate()
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const tabParam = queryParams.get('tab');
  const [activeContent, setActiveContent] = useState(tabParam || 'pending');
  const [pageNo, setPageNo] = useState(1)
  const [keyWord, setKeyWord] = useState('')
  const [error, setError] = useState('');
  const [showActionPopup, setShowActionPopup] = useState(false);
  const [activeButton, setActiveButton] = useState(tabParam || 'pending');
  const [selectedData, setSelectedData] = useState({
    status: "",
    id: "",
    rejectionReason: ""
  });
  const [count, setCount] = useState([])
  const [isViewModal, setIsViewModal] = useState(false)
  const [bankViewData, setBankViewData] = useState([])
  const [isLoading, setIsLoading] = useState(false)

  const debouncedKeyWord = useDebounce(keyWord, 500);

  function getCountList() {
    coinManagementActions.getAmountAndCount({ type: "BANK_APPROVAL_INDIVIDUAL" }).then((res) => {
      if (res) {
        setCount(res?.data)
      }
    }).catch((err) => console.log(err))
  }
  useEffect(() => {
    getCountList()
  }, []);

  useEffect(() => {
    setPageNo(1);
  }, [debouncedKeyWord, activeContent]);

  const details = {
    keyWord: debouncedKeyWord,
    status: activeContent,
    fromDate: "",
    toDate: "",
    sortBy: "createdAt",
    sortOrder: "desc",
    pageNo: pageNo,
    size: size, isUserBank: true,
  }

  useEffect(() => {
    dispatch(userManagementActions?.userBankDetailsList(details))
  }, [debouncedKeyWord, pageNo, size, activeContent]);

  useEffect(() => {
    setBankList(selector?.userManagement?.getUserBankDetails?.list)
  }, [selector]);

  const updateUrlParams = (tab, page) => {
    const params = new URLSearchParams();
    params.set('tab', tab);

    navigate({
      pathname: location.pathname,
      search: params.toString()
    });
  };
  useEffect(() => {
    updateUrlParams(activeButton);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeButton]);

  const handleStatusChange = (status, id) => {
    const reqData = { status, id }
    if (status !== "approved") {
      reqData.rejectionReason = ""
    }
    setSelectedData(reqData);
    setShowActionPopup(true);
  };

  const handleContentChange = (content) => {
    setActiveContent(content);
  };


  const getStatusDetails = (content) => {

    switch (content) {
      case 'pending':
        return { statusTitle: 'Pending', updatedStatusDate: moment(content?.updatedAt).startOf('day').fromNow() };
      case 'approved':
        return { statusTitle: 'Approved', updatedStatusDate: moment(content?.updatedAt).startOf('day').fromNow() };
      case 'rejected':
        return { statusTitle: 'Declined', updatedStatusDate: moment(content?.updatedAt).startOf('day').fromNow() };
      case 'more-info':
        return { statusTitle: 'More Info Required', updatedStatusDate: moment(content?.updatedAt).startOf('day').fromNow() };
      default:
        return { statusTitle: 'Pending', updatedStatusDate: moment(content?.updatedAt).startOf('day').fromNow() };
    }
  };
  const { statusTitle, updatedStatusDate } = getStatusDetails(activeContent);

  const onPageChange = page => {
    setPageNo(page)
  }

  const handleButtonClick = (content) => {
    setActiveButton(content);
    handleContentChange(content);
    setPageNo(1);
  };


  const handleConfirm = () => {
    let errors = {};
    if ((selectedData?.status === "rejected" || selectedData?.status === "more-info") && !selectedData?.rejectionReason?.trim()) {
      errors.inputValue = "Please provide a reason.";
    }
    if (Object.keys(errors).length > 0) {
      setError(errors);
      return;
    }
    setIsLoading(true)
    userManagementActions.updateUserBankDetailsStatus(selectedData)
      .then((response) => {
        if (response) {
          dispatch(userManagementActions?.userBankDetailsList(details));
          dispatch(alertActions.success(response?.message || "Success."));
          getCountList()
          setSelectedData({
            status: "",
            id: "",
            rejectionReason: ""
          });
          setError({});
        }
      })
      .catch((err) => {
        dispatch(alertActions.error(err));
      }).finally(() => {
        setIsLoading(false)
      });

    setShowActionPopup(false);
  };


  const handleClose = () => {
    setShowActionPopup(false)
    setSelectedData({
      status: "",
      id: ""
    })
    setError({})
  }

  const handleViewAction = async (data) => {
    try {
      setIsViewModal(true);
      setIsLoading(true)
      const response = await kycVerificationListActions.viewRejectionsReasonsForBank({ id: data });
      if (response?.data) {
        setBankViewData(response.data);
      }
    } catch (error) {
      console.error("Failed to fetch KYC rejection reasons:", error);
    } finally {
      setIsLoading(false)
    }
  };

  return (
    <>
      <Loader loading={selector?.userManagement?.loading || isLoading} />
      <div className='p-6 space-y-2 overflow-hidden overflow-y-auto bg-gray-50'>
        <HeadingButton Heading='Redeem Bank  Request (Individual) '
          activeContent={activeContent}
          pendingCount={count?.pendingCount}
          approvedCount={count?.approvedCount}
          declinedCount={count?.rejectedCount}
          moreInfoCount={count?.moreInfoCount}
          handleButtonClick={handleButtonClick}

          activeButton={activeButton} />
        <SearchBar searchTerm={keyWord} setSearchTerm={setKeyWord} />
        {activeButton === 'pending' ? (bankList && bankList.filter(ele => ele?.verifiedStatus === 'pending').length > 0) ? (
          bankList.filter(ele => ele?.verifiedStatus === 'pending').map((ele, idx) => (
            <div className='space-y-3' key={idx}>
              <BankStatement
                kycAddressDoc={ele?.passbookImage}
                accountName={ele?.accountHolderName}
                accountNumber={ele?.accountNumber}
                ifscCode={ele?.ifscCode}
                bankName={ele?.bankName}
                branch={ele?.branchName}
                swiftCode={ele?.swiftCode}
                bankAddress={ele?.branchAddress}
                statusTitle={statusTitle}
                updatedStatusDate={updatedStatusDate}
                handleReject={() => handleStatusChange("rejected", ele._id)}
                handleApprove={() => handleStatusChange("approved", ele._id)}
                handleMoreInfo={() => handleStatusChange("more-info", ele._id)}
                verifiedBy={ele?.verifiedBy}
                id={ele?._id}
                handleAction={handleViewAction}
                date={ele?.updatedAt}
                userName={ele?.userId?.name}
                userEmail={ele?.userId?.email}

              />
            </div>
          ))
        ) : (
          <div className='mt-2 border border-gray-300 rounded-md'>
            <Nodata
              nodataLabel={"No Data found"}
              nodataDesc={"There are no Data to display"}
            />
          </div>
        ) : null}
        {activeButton === 'approved' ? (bankList && bankList.filter(ele => ele?.verifiedStatus === 'approved').length > 0) ? (
          bankList.filter(ele => ele?.verifiedStatus === 'approved').map((ele, idx) => (
            <div className='space-y-3' key={idx}>
              <BankStatement
                kycAddressDoc={ele?.passbookImage}
                accountName={ele?.accountHolderName}
                accountNumber={ele?.accountNumber}
                ifscCode={ele?.ifscCode}
                bankName={ele?.bankName}
                branch={ele?.branchName}
                swiftCode={ele?.swiftCode}
                bankAddress={ele?.branchAddress}
                statusTitle={statusTitle}
                updatedStatusDate={updatedStatusDate}
                verifiedBy={ele?.verifiedBy}
                id={ele?._id}
                handleAction={handleViewAction}
                date={ele?.updatedAt}
                userName={ele?.userId?.name}
                userEmail={ele?.userId?.email}


              />
            </div>
          ))
        ) : (
          <div className='mt-2 border border-gray-300 rounded-md'>
            <Nodata
              nodataLabel={"No Data found"}
              nodataDesc={"There are no Data to display"}
            />
          </div>
        ) : null}
        {activeButton === 'rejected' ? (bankList && bankList.filter(ele => ele?.verifiedStatus === 'rejected').length > 0) ? (
          bankList.filter(ele => ele?.verifiedStatus === 'rejected').map((ele, idx) => (
            <div className='space-y-3' key={idx}>
              <BankStatement
                kycAddressDoc={ele?.passbookImage}
                accountName={ele?.accountHolderName}
                accountNumber={ele?.accountNumber}
                ifscCode={ele?.ifscCode}
                bankName={ele?.bankName}
                branch={ele?.branchName}
                swiftCode={ele?.swiftCode}
                bankAddress={ele?.branchAddress}
                statusTitle={statusTitle}
                updatedStatusDate={updatedStatusDate}
                verifiedBy={ele?.verifiedBy}
                id={ele?._id}
                handleAction={handleViewAction}
                date={ele?.updatedAt}
                userName={ele?.userId?.name}
                userEmail={ele?.userId?.email}


              />
            </div>
          ))
        ) : (
          <div className='mt-2 border border-gray-300 rounded-md'>
            <Nodata
              nodataLabel={"No Data found"}
              nodataDesc={"There are no Data to display"}
            />
          </div>
        ) : null}
        {activeButton === 'more-info' ? (bankList && bankList.filter(ele => ele?.verifiedStatus === 'more-info').length > 0) ? (
          bankList.filter(ele => ele?.verifiedStatus === 'more-info').map((ele, idx) => (
            <div className='space-y-3' key={idx}>
              <BankStatement
                kycAddressDoc={ele?.passbookImage}
                accountName={ele?.accountHolderName}
                accountNumber={ele?.accountNumber}
                ifscCode={ele?.ifscCode}
                bankName={ele?.bankName}
                branch={ele?.branchName}
                swiftCode={ele?.swiftCode}
                bankAddress={ele?.branchAddress}
                statusTitle={statusTitle}
                updatedStatusDate={updatedStatusDate}
                verifiedBy={ele?.verifiedBy}
                id={ele?._id}
                handleAction={handleViewAction}
                date={ele?.updatedAt}
                userName={ele?.userId?.name}
                userEmail={ele?.userId?.email}


              />
            </div>
          ))
        ) : (
          <div className='mt-2 border border-gray-300 rounded-md'>
            <Nodata
              nodataLabel={"No Data found"}
              nodataDesc={"There are no Data to display"}
            />
          </div>
        ) : null}
      </div>

      <ActionPopup
        inputValue={selectedData?.rejectionReason ?? ""}
        handleInputValue={(value) =>
          setSelectedData((prev) => ({
            ...prev,
            rejectionReason: value
          }))
        }
        handleConfirm={handleConfirm}
        onClose={handleClose}
        showActionPopup={showActionPopup}
        heading={`Are you sure you want to ${selectedData?.status}?`}
        showInput={false} // input is no longer used
        inputPlaceholder="Enter rejection reason..."
        imageUrl="/warning.png"
        // statusHeading={selectedData?.status}
        inputError={error}
        isNote={selectedData?.status === "rejected" || selectedData?.status === "more-info"}
        noteValue={selectedData?.rejectionReason}
        noteChange={(value) =>
          setSelectedData((prev) => ({
            ...prev,
            rejectionReason: value
          }))
        }
      />


      {Math.ceil((selector?.userManagement?.getUserBankDetails?.total || 0) / size) > 1 && (
        <Pagination
          totalPages={Math.ceil((selector?.userManagement?.getUserBankDetails?.total || 0) / size)}
          currentPage={pageNo}
          onPageChange={onPageChange} />
      )}


      <ViewHistoryModal
        isOpen={isViewModal}
        onClose={() => setIsViewModal(false)}
        heading="History"
        data={bankViewData}
        isNotesData={false}
        isApiResData={true}

      />

    </>
  )
}

export default BankRequestIndividual